import React from 'react';
export const CTAButton = () => {
  return <a href="https://provitalnosc.pl/products/provitalnosc-najlepszy-naturalny-probiotyk-na-menopauze" className="inline-block bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-8 rounded-full text-xl shadow-lg transition-all transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50" data-id="element-339">
      ZAMÓW PROVITALNOŚĆ TERAZ
    </a>;
};